import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.502 15.5606L1.50195 7.56056L2.4985 6.43944L11.0002 13.9965L19.502 6.43944L20.4985 7.56056L11.4985 15.5606C11.2143 15.8131 10.7861 15.8131 10.502 15.5606Z"
    />
  </svg>
);
